import React,{useState,useEffect} from 'react'
import { Route, Switch, useParams  } from 'react-router-dom'
import { TextBody, Container, ImageDetail, Title, WrappDetail, Wrapper, WrappRecomendation, Box, Span, Description, DescriptionSide } from '../../globalStyle'
import Not from '../../assets/images/notfound.svg'
import ImageError from '../error/error'
import { url } from '../../App'

function SkillDetail(){
    const {id} = useParams();
    const [ data, setData ] = useState([]);
    const [ data2, setData2 ] = useState([]);

    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    useEffect(() => {
        const Detail = async() => {
            setLoading(true)
            try{
                let res = await fetch(`${url}/skill/${id}`)
                let data = await res.json()
                setData(data.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        Detail()
        
    },[id])
    useEffect(() => {
        const getSkill = async() => {
            setLoading(true)
            try{
                let skill = await fetch(`${url}/get-skill3`)
                let data2 = await skill.json()
                console.log(data2);
                setData2(data2.data)
            }catch(error){
                setError(true)
            }finally{
                setLoading(false)
            }
        }
        getSkill()
      
    },[])
    
   if(error){
       return(
           <ImageError />
       )
   }
//    if(loading){
//        return(
//            <p>Mohon Tunggu Sebentar.</p>
//        )
//    }
    return(
        <>
        
        <Container>
            <Wrapper>
                <WrappDetail>
                        <ImageDetail src={data ? data.image : Not} alt="Image" />
                        <Title>{data ? data.nama : 'Mohon maaf Data tidak tersedia !!'}</Title>
                        <TextBody>{data ? data.body : ""}</TextBody>
                </WrappDetail>
                <WrappRecomendation>
                        <p>Rekomendasi :</p>
                        {   
                        data && 
                            data2.map(item=>{
                                return(
                                        item.image ===  data.image ? null : (
                                                <Box to={'/skills/'+item.id} key={item.id}>
                                                    <img src={item.image} width={240} alt="Image data 2" /> 
                                                    <DescriptionSide>{item.body.substr(0,40) + '...' }</DescriptionSide>
                                                    <Span />
                                                </Box>
                                        )
                                )
                            })
                        }
                    
                </WrappRecomendation>
            </Wrapper>

        </Container>
        </>
    )
}
export default SkillDetail 